module.exports = __webpack_public_path__ + "static/img/3.2d6ca33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R134A/3.jpg
// module id = 6v/0
// module chunks = 1